module.exports = __webpack_public_path__ + "static/media/icon_azure-databricks.f7d093dd.svg";